export default "__VITE_ASSET__D8KRElh2__"